package com.downdogapp.client

data class YearMonthDay(val year: Int, val month: Int, val day: Int) {

  constructor(yearMonth: YearMonth, day: Int) : this(yearMonth.year, yearMonth.month, day)

  val yearMonth
    get() =
      YearMonth(year, month)

  fun dayOfWeek(firstDayOfWeek: FirstDayOfWeek) =
    CalendarHelper.dayOfWeek(this, firstDayOfWeek)

  val weekdayName
    get() =
      CalendarHelper.weekdayName(this)

  private fun jumpBackwardsDay(numberOfDaysToMoveBackward: Int) = when {
    day > numberOfDaysToMoveBackward -> YearMonthDay(year, month, day - numberOfDaysToMoveBackward)
    month > 0 -> YearMonthDay(
      year,
      month - 1,
      day + yearMonth.previousMonth().numDaysInMonth - numberOfDaysToMoveBackward
    )

    else -> YearMonthDay(year - 1, 11, day + 31 - numberOfDaysToMoveBackward)
  }

  fun previousDay() = jumpBackwardsDay(1)
  fun previousWeek() = jumpBackwardsDay(7)
  fun getStartOfWeek(firstDayOfWeek: FirstDayOfWeek) = jumpBackwardsDay(dayOfWeek(firstDayOfWeek))

  operator fun compareTo(other: YearMonthDay) = when {
    year != other.year -> year - other.year
    month != other.month -> month - other.month
    else -> day - other.day
  }

  companion object {

    val today
      get() =
        CalendarHelper.today

    val yesterday
      get() =
        today.previousDay()

    fun fromTimestampMillis(timestamp: Long) =
      CalendarHelper.yearMonthDayFromMillis(timestamp)

    fun fromTimestampSeconds(timestamp: Double) =
      CalendarHelper.yearMonthDayFromSeconds(timestamp)
  }
}
